export const POINTS_ALREADY_HAS_ACCOUNT =
  "This person already has a Points account. Please go back and enter a different email address.";
export const CASH_CANNOT_SETUP_POINTS = "This person can't be set up with a Points account.";

export function pointsMembershipMessageFromUser(user) {
  if (!user || (!user.invalid && !user.failed)) return null;
  return user.invalidReason || user.failedReason || null;
}

export function firstPointsMembershipMessage(rows) {
  const list = Array.isArray(rows) ? rows : [];
  for (const row of list) {
    const message = pointsMembershipMessageFromUser(row);
    if (message) return message;
  }
  return null;
}

export function pointsMembershipMessageFromError(err) {
  if (!err) return null;
  if (typeof err.invalid === "string" && err.invalid) return err.invalid;
  const appended = err.append?.data || err.data;
  const fromRows = firstPointsMembershipMessage(appended);
  if (fromRows) return fromRows;
  return pointsMembershipMessageFromUser(err);
}

const POINTS_TRANSFER_FALLBACK =
  "This person can't be moved to that client because of a Points membership.";

export function isPointsTransferError(errorCode) {
  if (errorCode == null) return false;
  const code = String(errorCode);
  return code === "1030209" || code.endsWith("209") || Number(errorCode) === 209;
}

export function pointsMembershipMessageFromTransferError(err) {
  if (!err || !isPointsTransferError(err.error_code)) return null;
  if (typeof err.supplement === "string" && err.supplement) return err.supplement;
  if (typeof err.error === "string" && err.error) return err.error;
  return POINTS_TRANSFER_FALLBACK;
}
